import { render, staticRenderFns } from "./buttonSelector.vue?vue&type=template&id=fe085454&scoped=true&lang=html&"
import script from "./buttonSelector.vue?vue&type=script&lang=js&"
export * from "./buttonSelector.vue?vue&type=script&lang=js&"
import style0 from "./buttonSelector.vue?vue&type=style&index=0&id=fe085454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe085454",
  null
  
)

export default component.exports